module.exports = __webpack_public_path__ + "img/score_device_ar.bd0f134f.png";